import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { SyncRun } from "@modules/syncReceivedBooks/types";

import { ListSyncRunsParams } from "./types";

export async function listSyncRunsService(
  params?: ListSyncRunsParams
): Promise<ApiResponse<SyncRun>> {
  const { data } = await api.get<ApiResponse<SyncRun>>(
    "v2/bookstore/sync_received_books_custom_filters/",
    { params }
  );

  return data;
}
